








import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { IPortalUser } from "../../../models/interfaces/authentication/portal-user.model.interface";
import { State, Getter, Action, namespace } from "vuex-class";
import SuccessMessage from "@/components/SuccessMessage.vue";

const UserModule = namespace("userManagementModule");

@Component({
    components: {
        SuccessMessage
    }
})
export default class BlockUserButton extends Vue {
    @UserModule.Getter public user: IPortalUser | null;
    @UserModule.Action public block;
    @UserModule.Action public unBlock;

    @Provide() public userModel: IPortalUser;

    private lastSaved: Date | null = null;

    private blockedMessage: string = "";

    public created() {
        this.setCurrentUser(this.user);
    }

    get getUser(): IPortalUser | null {
        return this.user;
    }

    get isUserBlocked(): boolean {
        if (this.user) {
            return this.user.blocked;
        }

        return false;
    }

    @Watch("getUser")
    public onUserChanged(val: IPortalUser | null, oldVal: IPortalUser | null) {
        this.setCurrentUser(val);
    }

    public setCurrentUser(val: IPortalUser | null) {
        if (val) {
            this.userModel = val;
        }
    }

    public blockUser() {
        if (this.getUser) {
            this.block(this.getUser.id).then((result) => {
                if (result) {
                    this.blockedMessage = "User Blocked";
                    this.lastSaved = new Date();
                }
            });
        }
    }

    public unBlockUser() {
        if (this.getUser) {
            this.unBlock(this.getUser.id).then((result) => {
                if (result) {
                    this.blockedMessage = "User Unblocked";
                    this.lastSaved = new Date();
                }
            });
        }
    }
}
